<template>
    <div class="container remove-padding">
        <div class="header-top bg-white">
            <div class="row justify-content-center align-items-center set-row w-limit">
                <div class="col-md-3 col-sm-3 col-3 remove-padding" v-on:click="closeCreateOutlet">
                    <img src="../../assets/img/x2.svg">
                </div>
                <div class="col-md-7 col-sm-7 col-7 text-center remove-padding">
                    <div class="remove-margin font-16 font-colorcheck text-promo">Tambah Outlet</div>
                </div>
                <div class="col-md-2 col-sm-2 col-2">
                </div>
            </div>
        </div>
        <!--        <div class="pembatas">-->
        <!--        </div>-->
        <main class="add-padding-default w-limit">
            <div class="flex-100">
                <div class="flex-1 pad-top-50">
                    <div class="animasi-card  bg-transparent d-flex mar-top-16 mar-bottom-16">
                        <div class="font-16 status-login color-206CF"><span class="font-weight-bold color-206CF">Langkah 1/2</span>
                        </div>
                    </div>
                    <div class="color-0000 font-16 letter-space-002 line-height-25 mar-bottom-16">
                        Data ini akan ditampilkan pada nota transaksi untuk konsumen
                    </div>
                    <form action="">
                        <div class="form-group">
                            <label class="remove-margin color-6f7 font-14 require" for="namaoutlet">Nama Outlet</label>
                            <input type="text" class="form-control inputs" id="namaoutlet" aria-describedby="emailHelp"
                                   placeholder="Clean Laundry" v-model="dataDataOutlet.nameOutlet"
                                   v-on:keyup="inputnama">
                            <ErrorMessage class="error" label="Nama Outlet"
                                          :validation="$v.dataDataOutlet.nameOutlet"></ErrorMessage>

                            <label class="remove-margin mar-top-12 color-6f7 font-14 require" for="phone">Nomor Telpon
                                Outlet</label>
                            <div class="input-group remove-padding">
                                <vue-country-code
		                            @onSelect="onSelect" :preferredCountries="['id', 'my', 'bn']">
	                            </vue-country-code>
                                <input type="tel" class="form-control inputs" id="phone" placeholder="81757875431"
                                       v-on:keyup="nomorWaOnkeyup" v-model="dataDataOutlet.telp">
                            </div>
                            <ErrorMessage class="error" label="Nomor Telepon"
                                          :validation="$v.dataDataOutlet.telp"></ErrorMessage>


                            <div class="mod">
                                <label class="remove-margin mar-top-12 color-6f7 font-14 require">Kota</label>
                                <Select2 class="test-select fl-is-required inputs" id="select2"
                                         v-on:change="cekValidate"
                                         v-model="dataDataOutlet.selectedkota" :options="dataDataOutlet.optionskota"
                                         :settings="{ placeholder: 'Pilih Kota' }"
                                         @change="myChangeEvent($event);"
                                />
                            </div>
                            <ErrorMessage class="error" label="Kota"
                                          :validation="$v.dataDataOutlet.selectedkota"></ErrorMessage>

                            <label class="remove-margin mar-top-12 color-6f7 font-14 require"
                                   for="alamat">Alamat</label>
                            <textarea type="text" class="form-control inputs" id="alamat" aria-describedby="emailHelp"
                                      placeholder="Jln. Jendral Bersih Selalu No. 1" v-on:keyup="inputalamat"
                                      v-model="dataDataOutlet.alamat"></textarea>
                            <ErrorMessage class="error" label="Alamat"
                                          :validation="$v.dataDataOutlet.alamat"></ErrorMessage>
                        </div>
                    </form>
                    <div class="line-patah mar-bottom-20 atribute" id="imagePreview">
                        <img src="" alt="" style="max-width: 70px" id="logo" v-model="dataDataOutlet.logourl">
                        <div class="inputupload">
                            <label for="file" class="remove-margin row remove-margin align-items-center">
                                <img src="../../assets/img/camera1-img.svg" alt="" style="max-width: 70px">
                                <div class="font-14 color-6f7 justify-content-center" style="margin-left: 5px">Upload
                                    Logo Outlet
                                </div>
                            </label>
                            <input type='file' id="file" ref="file" v-on:change="handleFileUpload"
                                   accept=".png, .jpg, .jpeg"/>
                        </div>
                        <div class="font-12 colorC8D0DD line-height-25 letter-space-002"><small>Maksimal 2MB</small>
                        </div>
                    </div>
                </div>
                <div class="button-lanjut ">
                    <button class="btn btn-login btn-long remove-margin" id="Btndataoutlet"
                            @click="ceknameoutlet">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="dataDataOutlet.isClicked === true"></span><span
                            id="textBtndataoutlet">Berikutnya</span>
                    </button>
                </div>
            </div>
        </main>
        <div class="modal fade" id="modal-lewati-panduan" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content w-limit">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Batal Mengikuti Panduan</h5>
                        <div class="nav-btn kanan tutup">
                        </div>
                    </div>
                    <div class="modal-body">
                        <p>Anda sedang mengikuti panduan pengguna, batal mengikuti panduan akan menghentikan mode
                            panduan. Apakah Anda yakin ingin keluar dari panduan?</p>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-long m-d-20"
                                data-dismiss="modal">
                            Lanjutkan Panduan
                        </button>
                        <a @click="skipOnboarding(3)" class="m-t-20 f-semi f-12 f-c-blue">Saya Ingin Keluar
                            Dari Mode Panduan</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modal" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content w-limit">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Batal Membuat Outlet</h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body">
                        <p>Apakah anda yakin ingin membatalkan pembuatan outlet baru? </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                                @click="back">Ya, Batalkan
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import ErrorMessage from "../../component-items/ErrorMessage";
    import {required, minLength, maxLength} from 'vuelidate/lib/validators'

    export default {
        name: "DataOutlet",
        components: {Select2, ErrorMessage},
        mounted() {
            this.getkota()
            $('#close').hide()
            this.cekValidate()
            this.backButtonPressed(this.closeCreateOutlet)
            this.smartTrackingView("add_outlet_step1");

        },
        data(){
          return{
	          telpCode: "",
          }
        },
        validations: {
            dataDataOutlet: {
                nameOutlet: {
                    required,
                    minLength: minLength(2),
                },
                telp: {
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(12),
                },
                selectedkota: {
                    required,
                    minLength: minLength(1),
                },
                alamat: {
                    required,
                    minLength: minLength(2),
                },
                telp_code: {
                  required
                }
            }
        },
        props: ["dataDataOutlet"],
        methods: {
            onSelect({name, iso2, dialCode}) {
              this.telpCode=dialCode;
              this.dataDataOutlet.telp_code= dialCode;
            },
            next() {
                this.$emit("showProductionProcess")
            },
            back() {
                $("#modal-lewati-panduan").modal("hide")
                $("#modal").modal("hide")
                this.$emit('golistoutlet')
            },
            closeCreateOutlet() {
                const stepWalkthrough = localStorage.getItem("step_walkthrough")
                if (stepWalkthrough != undefined && stepWalkthrough != null && stepWalkthrough == '0') {
                    $("#modal-lewati-panduan").modal("show")
                } else {
                    $("#modal").modal("show")
                }
            },

            async skipOnboarding(params) {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                if (localStorage.getItem("step_walkthrough") !== undefined && localStorage.getItem("step_walkthrough") !== null) {
                    try {
                        const datawalkthrough = new FormData
                        datawalkthrough.append('walkthrough', params)
                        const response = await this.$axios.post(this.$baseurl + '/masterData/owner/update_status_walkthrough', datawalkthrough, this.dataDataOutlet.requestHeaders);
                        if (response.data.code === 200) {
                            if (response.data.status === true) {
                                localStorage.setItem("step_walkthrough", params)
                                this.back()
                            }
                        } else {
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            this.popupType = "error";
                            this.popupMessage = response.data.msg;
                        }
                    } catch (e) {
                        if (!e.code) {
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            this.popupType = "error";
                            this.popupErrorException = e;
                        }
                    }
                } else {
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                    this.$emit('golistoutlet')
                }
            },

            inputnama(event) {
                var name = event.target.value;
                var handle = name.replace(/[^0-9A-Za-z_.,'()& -]+/, '');
                this.dataDataOutlet.nameOutlet = handle;
                this.cekValidate()
            },

            inputalamat(event) {
                var name = event.target.value;
                var handle = name.replace(/[^0-9A-Za-z/_.,' -]+/, '');
                this.dataDataOutlet.alamat = handle;
                this.cekValidate()
            },

            handleFileUpload() {
                this.dataDataOutlet.logourl = this.$refs.file.files[0];
                var FileSize = this.$refs.file.files[0].size / 1024 / 1024;
                var validphoto = [".jpg", ".jpeg", ".bmp", ".gif", ".png"];

                if (FileSize > 2) {
                    this.$toast.error('File Gambar tidak boleh lebih dari 2 MB, file anda ' + FileSize.toFixed(2) + ' MB')
                    $('#file').val("");
                    $('#logo').attr('src', '/img/camera1.75d479aa.svg');
                } else {
                    var blnValid = false;
                    for (var j = 0; j < validphoto.length; j++) {
                        var sCurExtension = validphoto[j];
                        if (this.dataDataOutlet.logourl.name.substr(this.dataDataOutlet.logourl.name.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                            blnValid = true;
                        }
                    }
                    if (!blnValid) {
                        this.$toast.error('File photo harus menggunakan format jpg, jpeg, dan png')
                    } else {
                        $('#logo').attr('src', URL.createObjectURL(this.$refs.file.files[0]));
                    }
                }

            },

            cekValidate() {
                return;
                var kota = this.dataDataOutlet.selectedkota;
                var namaOutlet = this.dataDataOutlet.nameOutlet;
                var telp = this.dataDataOutlet.telp;
                var alamat = this.dataDataOutlet.alamat;
                var lenPass = namaOutlet.length;
                if (lenPass >= 2 && kota !== '1' && (telp.length >= 8 && telp.length <= 14) && alamat.length >= 2) {
                    $('#Btndataoutlet').prop('disabled', false);
                } else {
                    $('#Btndataoutlet').prop('disabled', true);
                }
            },
            myChangeEvent(val) {
                this.myValue = val
            },
            async getkota() {
                this.optionskota = [];
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/kota_meta', this.dataDataOutlet.requestHeaders)
                    if (response.status === 200) {
                        var rawkota = response.data.data;
                        this.dataDataOutlet.optionskota.push({id: "", text: "Pilih Kota"})
                        for (var i = 0; i < rawkota.length; i++) {
                            this.dataDataOutlet.optionskota.push({id: rawkota[i].id, text: rawkota[i].nama})
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    this.dataProductionActivity.isClicked = false
                    $('#textBtn2').show();
                    $('#btnNext').prop('disabled', false);
                }

            },
            nomorWaOnkeyup(event) {
                var phoneField = event.target.value;
                var frstCar = phoneField.substring(0, 1);
                var firstTel = phoneField.substring(1, 13);
                var secCar = phoneField.substring(0, 2);
                var secTel = phoneField.substring(2, 13);
                var thrdcar = phoneField.substring(0, 12);
                var output


                if (frstCar == 0) {
                    output = firstTel
                } else if (secCar == this.telpCode) {
                    output = secTel
                } else {
                    output = thrdcar
                }
                var number = output.replace(/[^0-9]+/, '');

                var charLenght = number.length;
                if (charLenght >= 8 && charLenght <= 12) {
                    // $('#btnNext').prop('disabled', false);
                } else {
                    // $('#btnNext').prop('disabled', true);
                }
                this.dataDataOutlet.telp = number;
                this.cekValidate()
            },

            async ceknameoutlet() {
                if (this.$v.dataDataOutlet.$invalid) {
                    this.$v.dataDataOutlet.$touch()
                    this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
                    this.smartTrackingErrorValidate("add_outlet_step1",{"errorMsg":"Form belum dilengkapi"});

                    return
                }

                this.dataDataOutlet.isClicked = true
                $('#textBtndataoutlet').hide()
                $('#Btndataoutlet').prop('disabled', true);
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/outlet/cek_nama_outlet_tersedia?nama_outlet=' + this.dataDataOutlet.nameOutlet, this.dataDataOutlet.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.next()
                            this.dataDataOutlet.isClicked = false;
                            $('#textBtndataoutlet').show();
                            $('#Btndataoutlet').prop('disabled', false);
                            this.smartTrackingView("add_outlet_step2");

                        } else {
                            this.$toast.error(response.data.msg)
                            this.dataDataOutlet.isClicked = false;
                            $('#textBtndataoutlet').show();
                            $('#Btndataoutlet').prop('disabled', false);
                            this.smartTrackingErrorValidate("add_outlet_step1",{"errorMsg":response.data.msg});

                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    this.dataDataOutlet.isClicked = false;
                    $('#textBtndataoutlet').show();
                    $('#Btndataoutlet').prop('disabled', false);
                    this.smartTrackingErrorValidate("add_outlet_step1",{"errorMsg":"error server"});
                }
            }
        },
    }
</script>

<style scoped>

    .line-patah {

    }

    .inputupload > input {
        display: none;
    }

    .inputupload img {
        cursor: pointer;
    }

    .inputupload {
        display: flex;
        justify-content: center;
    }

    .modal {
        overflow: hidden;
        left: auto;
    }

    @media (max-width: 420px) {
        .modal {
            overflow: hidden;
            left: 0;
        }
    }
</style>